export const MAIL_LOGS_TABLE_KEYS = {
    PASSWORD_OR_PROJECT_DETAILS: "passwordOrProject",
    ACTION:"action"
}

export const MAIL_LOGS_TABLE_HEADERS = {
    [MAIL_LOGS_TABLE_KEYS.PASSWORD_OR_PROJECT_DETAILS]: "Password/Project Details",
    [MAIL_LOGS_TABLE_KEYS.ACTION] :"Re-Send Mail"
}

